module.exports = __webpack_public_path__ + "img/location.49dc097a.png";